import { render, staticRenderFns } from "./VisitLink.vue?vue&type=template&id=13108afd&"
import script from "./VisitLink.vue?vue&type=script&lang=js&"
export * from "./VisitLink.vue?vue&type=script&lang=js&"
import style0 from "./VisitLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports